import { IVillageDictionary } from '@/dictionaries/pages/village/types';
import { VillageTranslation } from '@/services/types';

type Props = {
  translations: VillageTranslation;
  villageDict: IVillageDictionary;
};

export default function DescriptionContent({
  translations,
  villageDict,
}: Props) {
  const { description } = villageDict;
  const outdoorDescription = translations['outdoorDescription']?.replace(
    /\n/g,
    '<br />',
  );

  const indoorDescription = translations['indoorDescription']?.replace(
    /\n/g,
    '<br />',
  );

  const surroundingsAndActivities = translations[
    'surroundingsAndActivitiesDescription'
  ]?.replace(/\n/g, '<br />');

  return (
    <div>
      <div className="mb-[40px]">
        <span className="inline-block mb-[10px] text-xl font-semibold">
          {description.outdoor}
        </span>
        <div>
          <div
            className="leading-[1.6] [&>p]:mb-4 [&>p>a]:bg-gradient-to-b [&>p>a]:from-underline [&>p>a]:to-underline [&>p>a]:bg-no-repeat [&>p>a]:bg-[length:95%_3px] [&>p>a]:py-0 [&>p>a]:px-[5px] [&>p>a]:my-0 [&>p>a]:mx-[-5px] [&>p>a]:bg-bottom [&>p>a:hover]:bg-[length:95%_15px] [&>p>a]:transition-all [&>p>a]:ease-in-out [&>p>a]:duration-500 [&>p>a]:z-1 [&>p>a]:break-normal"
            dangerouslySetInnerHTML={{ __html: outdoorDescription || '' }}
          />
        </div>
      </div>
      <div className="mb-[40px]">
        <span className="inline-block mb-[10px] text-xl font-semibold">
          {description.indoor}
        </span>
        <div>
          <div
            className="leading-[1.6] [&>p]:mb-4 [&>p>a]:bg-gradient-to-b [&>p>a]:from-underline [&>p>a]:to-underline [&>p>a]:bg-no-repeat [&>p>a]:bg-[length:95%_3px] [&>p>a]:py-0 [&>p>a]:px-[5px] [&>p>a]:my-0 [&>p>a]:mx-[-5px] [&>p>a]:bg-bottom [&>p>a:hover]:bg-[length:95%_15px] [&>p>a]:transition-all [&>p>a]:ease-in-out [&>p>a]:duration-500 [&>p>a]:z-1 [&>p>a]:break-normal"
            dangerouslySetInnerHTML={{ __html: indoorDescription || '' }}
          />
        </div>
      </div>
      {surroundingsAndActivities && (
        <div className="mb-[40px]">
          <span className=" inline-block mb-[10px] text-xl font-semibold">
            {description.surroundingsAndActivies}
          </span>
          <div>
            <div
              className="leading-[1.6] [&>p]:mb-4 [&>p>a]:bg-gradient-to-b [&>p>a]:from-underline [&>p>a]:to-underline [&>p>a]:bg-no-repeat [&>p>a]:bg-[length:95%_3px] [&>p>a]:py-0 [&>p>a]:px-[5px] [&>p>a]:my-0 [&>p>a]:mx-[-5px] [&>p>a]:bg-bottom [&>p>a:hover]:bg-[length:95%_15px] [&>p>a]:transition-all [&>p>a]:ease-in-out [&>p>a]:duration-500 [&>p>a]:z-1 [&>p>a]:break-normal"
              dangerouslySetInnerHTML={{
                __html: surroundingsAndActivities || '',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
